export const CLAIM_PATTERNS = {
  PART_NUMBER: /^[a-zA-Z0-9/-]*$/,
  CLAIM_NUMBER: /^[\d-]*$/,
  INVOICE_NUMBER: /^[\d-]*$/,
  NFE_NUMBER: /^[a-zA-Z0-9-]*$/,
  PART_NUMBER_V2: /^[a-zA-Z0-9/-]{0,30}$/,
  DEALER_ACCOUNT: /^[a-zA-Z0-9]{0,6}$/,
};

export const AllClaimsSortFieldMap = new Map([
  ["claimNumber", "CLAIM_NUMBER"],
  ["type", "CLAIM_TYPE"],
  ["dealerReference", "DEALER_REFERENCE"],
  ["invoiceNumber", "INVOICE_NUMBER"],
  ["handlingUnitNumber", "HANDLING_UNIT_NUMBER"],
  ["notaFiscalNumber", "NOTA_FISCAL_NUMBER"],
  ["createdBy", "CREATED_BY"],
  ["createdDate", "CREATED_DATE"],
  ["dealerAccount", "DEALER_ACCOUNT"],
]);

export const JDP_SHORTAGE_OVERAGE = "JDP Shortage/Overage";

export const VENDORE_DIRECT_SHORTAGE_OVERAGE = "Vendor Direct Overage/Shortage";
